import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import rootSlice from './root-slice';

const reducer = combineReducers({
    root: rootSlice.reducer,
});

const storeMobile = configureStore({
    reducer,
})

export const rootActionsMobile = rootSlice.actions;
export default storeMobile;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootStateMobile = ReturnType<typeof storeMobile.getState>;
export type AppDispatchMobile = typeof storeMobile.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatchMobile = () => useDispatch<AppDispatchMobile>();
export const useAppSelectorMobile: TypedUseSelectorHook<RootStateMobile> = useSelector;